// Admin translations - Chinese
export const zh = {
  // Auth
  "admin_panel": "管理面板",
  "setup_admin": "创建管理员账户",
  "admin_login": "管理员登录",
  "email": "电子邮件",
  "password": "密码",
  "confirm_password": "确认密码",
  "login": "登录",
  "logout": "登出",
  "setup": "创建账户",
  "office_email_only": "只有office@neuro-mesh.io可以成为管理员",
  "password_requirements": "密码必须至少14个字符，包含大写、小写、数字和特殊字符",
  
  // Navigation
  "dashboard": "仪表板",
  "users": "用户",
  "analytics": "分析",
  "export": "导出中心",
  "system_health": "系统健康",
  
  // Dashboard
  "overview": "概览",
  "total_users": "总用户数",
  "users_7d": "用户（7天）",
  "users_today": "今日用户",
  "total_sessions": "总会话数",
  "sessions_7d": "会话（7天）",
  "cerebro_events": "Cerebro事件",
  "robomesh_events": "RoboMesh事件",
  "visits_over_time": "访问量随时间变化",
  "mode_split": "模式使用分布",
  
  // Users
  "user_list": "用户列表",
  "search_users": "搜索用户...",
  "name": "姓名",
  "provider": "提供商",
  "created_at": "创建时间",
  "last_active": "最后活跃",
  "sessions": "会话",
  "actions": "操作",
  "view_details": "查看详情",
  
  // Analytics
  "event_types": "事件类型",
  "mode_usage": "模式使用",
  "last_30_days": "最近30天",
  
  // Export
  "export_data": "导出数据",
  "export_users": "导出用户",
  "export_sessions": "导出会话",
  "format": "格式",
  "csv": "CSV",
  "json": "JSON",
  "download": "下载",
  
  // System Health
  "recent_events": "最近事件",
  "recent_audit_logs": "最近审计日志",
  "database_stats": "数据库统计",
  "status": "状态",
  "healthy": "健康",
  
  // Common
  "loading": "加载中...",
  "error": "错误",
  "success": "成功",
  "page": "页",
  "of": "共",
  "no_data": "无可用数据",
  "language": "语言",
  "english": "English",
  "chinese": "中文",
  "german": "Deutsch"
};
